/** Campaign-service — Instrument Info (BFP-257). */
export const SpSurveyPath = {
  instrumentInfo: (instrumentId: string) =>
    `/api/v1/sp/instruments/${encodeURIComponent(instrumentId)}/info`,
  instrumentStatus: (instrumentId: string) =>
    `/api/v1/sp/instruments/${encodeURIComponent(instrumentId)}/status`,
  responsesStart: (instrumentId: string) =>
    `/api/v1/sp/instruments/${encodeURIComponent(instrumentId)}/responses/start`,
  responseStartOver: (responseId: string) =>
    `/api/v1/sp/responses/${encodeURIComponent(responseId)}/start-over`,
  responseState: (responseId: string) =>
    `/api/v1/sp/responses/${encodeURIComponent(responseId)}`,
  saveAnswer: (responseId: string) =>
    `/api/v1/sp/responses/${encodeURIComponent(responseId)}/answers`,
  responseSubmit: (responseId: string) =>
    `/api/v1/sp/responses/${encodeURIComponent(responseId)}/submit`,
  responseAbandon: (responseId: string) =>
    `/api/v1/sp/responses/${encodeURIComponent(responseId)}/abandon`,
  pendingStart: (instrumentId: string) =>
    `/api/v1/sp/web-survey/pending/instruments/${encodeURIComponent(instrumentId)}/start`,
  pendingState: (pendingId: string) =>
    `/api/v1/sp/web-survey/pending/${encodeURIComponent(pendingId)}`,
  pendingSaveAnswer: (pendingId: string) =>
    `/api/v1/sp/web-survey/pending/${encodeURIComponent(pendingId)}/answers`,
  pendingRetain: (pendingId: string) =>
    `/api/v1/sp/web-survey/pending/${encodeURIComponent(pendingId)}/retain`,
  pendingAbandon: (pendingId: string) =>
    `/api/v1/sp/web-survey/pending/${encodeURIComponent(pendingId)}/abandon`,
  optionImage: (instrumentId: string, optionId: string) =>
    `/api/v1/sp/instruments/${encodeURIComponent(instrumentId)}/option-images/${encodeURIComponent(optionId)}`,
  questionVideo: (instrumentId: string, questionId: string) =>
    `/api/v1/sp/instruments/${encodeURIComponent(instrumentId)}/question-videos/${encodeURIComponent(questionId)}`,
} as const
